import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { onTourImageError } from "@/lib/imageFallback";

// Static category taxonomy (fixed domain enum): i18n key id, route slug, image.
const categories = [
  { id: "adventure", slug: "aventura", image: "https://images.unsplash.com/photo-1502943693086-33b5b1cfdf2f?w=800&q=80&auto=format&fit=crop" },
  { id: "cultural", slug: "cultural", image: "https://images.unsplash.com/photo-1545987796-200677ee1011?w=800&q=80&auto=format&fit=crop" },
  { id: "gastronomic", slug: "gastronomico", image: "https://images.unsplash.com/photo-1565299543923-37dd37887442?w=800&q=80&auto=format&fit=crop" },
  { id: "transport", slug: "transporte", image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&q=80&auto=format&fit=crop" },
  { id: "housing", slug: "hospedaje", image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80&auto=format&fit=crop" },
  { id: "fishing", slug: "pesca", image: "/brand/categories/pesca.jpg" },
];

export default function CategoriesSection() {
  const { t } = useTranslation("home");

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-offwhite">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-charcoal text-center mb-10 md:mb-14">
          {t("categories.title")}
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categoria/${cat.slug}`}
              className="group flex flex-col bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 border border-gray-100"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-gray-100">
                <img
                  src={cat.image}
                  alt={t(`categories.${cat.id}`)}
                  loading="lazy"
                  onError={onTourImageError}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="px-4 py-3 md:px-5 md:py-4 text-center">
                <h3 className="text-sm md:text-base font-semibold text-charcoal">
                  {t(`categories.${cat.id}`)}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}